// FLIP animation for the board: cards glide from where they were to where the next
// render puts them (First, Last, Invert, Play), with the Web Animations API.

const DURATION = 220
let pending = null // card number → rect before the change

/**
 * Remembers where all cards are now; the next render animates them from there.
 * `from`: start rects for single cards instead, e.g. the dropped card at the pointer.
 */
export function animateNextRender(from = {}) {
  pending = new Map(
    [...document.querySelectorAll('.card[data-number]')].map(el => [
      el.dataset.number,
      el.getBoundingClientRect(),
    ])
  )
  for (const [number, rect] of Object.entries(from))
    pending.set(String(number), rect)
}

/** After a render: plays the animation prepared by animateNextRender(), if any. */
export function playFlip() {
  if (!pending) return
  const before = pending
  pending = null
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return
  for (const el of document.querySelectorAll('.card[data-number]')) {
    const old = before.get(el.dataset.number)
    if (!old) continue
    const now = el.getBoundingClientRect()
    const dx = old.left - now.left
    const dy = old.top - now.top
    if (Math.abs(dx) < 1 && Math.abs(dy) < 1) continue
    el.animate(
      [{ transform: `translate(${dx}px, ${dy}px)` }, { transform: 'none' }],
      { duration: DURATION, easing: 'cubic-bezier(0.2, 0, 0, 1)' }
    )
  }
}
